const getExplicitRuntimeEnvironment = () => {
  return process.env.REACT_APP_RUNTIME_ENV || "";
};

export const getRuntimeEnvironment = () => {
  const explicitEnvironment = getExplicitRuntimeEnvironment().toLowerCase();

  if (explicitEnvironment === "development" || explicitEnvironment === "staging") {
    return explicitEnvironment;
  }

  if (typeof window === "undefined") {
    return "development";
  }

  const hostname = window.location.hostname.toLowerCase();

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".local") ||
    hostname.includes("localhost") ||
    hostname.startsWith("app-dev.") ||
    hostname.startsWith("dev.") ||
    hostname.includes("-dev.")
  ) {
    return "development";
  }

  return "production";
};

export const isDevelopmentRuntime = () => getRuntimeEnvironment() === "development";

export const getAppHostnamePrefix = () => {
  return isDevelopmentRuntime() ? "app-dev." : "";
};
